// extracted by mini-css-extract-plugin
export default {"listaProjetos":"PaginaInicial_listaProjetos__ftbh5"};